import React from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { updateStatusByRB, updateStatusByLP, 
  updateOutputFileStatus, setOutputFileAttribute } from './thunks';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavSub.css';

const NavSub = ({ mode, files, userInfo, groupInfo, reviewInfo, reviewAssignInfo,
  startUpdateOutputFileStatus, startUpdateStatusByRB, startUpdateStatusByLP,
  startSetOutputFileAttribute }) => {

  const onRbAgreeClick = (event) => {
    // const id = event.target.getAttribute('id');
    const value = event.target.getAttribute('data-value');
    // console.log('>>> onRbAgreeClick id:', id, value);
    const filename = getSelectedFileName(files);
    // {program}/{study}/{milestone}/{groupId}/{outputFile}/{requireChange}/{userId}
    const data = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      requireChange: value,
    };
    // console.log('>>> startUpdateStatusByRB data:', data);
    startUpdateStatusByRB(data);
  }

  const onLpAgreeClick = (event) => {
    const value = event.target.getAttribute('data-value');
    // console.log('>>> onLpAgreeClick id:', id, value);
    const filename = getSelectedFileName(files);
    const fileStatusId = getSelectFileStatusId();
    // {program}/{study}/{milestone}/{groupId}/{outputFile}/{requireChange}/{userId}
    const data = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      statusId: fileStatusId,
      requireChange: value,
    };
    // console.log('>>> startUpdateStatusByLP data:', data);
    startUpdateStatusByLP(data);
  }

  const onSelectReviewStatus = (event) => {
    const reviewStatusId = event.target.value;
    const filename = getSelectedFileName(files);
    // const fileStatusId = getSelectFileStatusId();
    // console.log('>>> onSelectReviewStatus', filename, reviewStatusId);
    const reviewData = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      statusId: reviewStatusId
    };
    // parameter: program, study, milestone, filename, statusId
    startUpdateOutputFileStatus(reviewData);
    
    setTimeout(() => {
      startSetOutputFileAttribute({
        fileName: filename,
        isSelected: true, 
      })
    }, 200);
  }

  const getSelectedFileName = (files) => {
    const [selectedFile] = files.filter( file => file.isSelected );
    return selectedFile && selectedFile.fileName;
  }

  const getSelectFileStatusId = () => {
    let statusId = 0;
    const [selectedFile] = files.filter( file => file && file.isSelected );
    if (selectedFile) {
      statusId = selectedFile.statusId || 0;
    }
    // console.log('>>> getSelectFileStatusId statusId:', statusId);
    return statusId;
  }

  const getCheckedValue = (type, yesno) => {
    let result = '';
    let fileValue = false;
    const [selectedFile] = files.filter( file => file && file.isSelected );
    // console.log('>>> getCheckedValue', type, yesno);
    if (!selectedFile) {
      return '';
    }
    if (type === 'RB') {
      fileValue = (selectedFile.requireChange === 'Yes');
      if (yesno === 'YES') {
        result = fileValue ? 'True' : '';
      } else {
        result = fileValue ? '' : 'True';
      }
    } else if (type === 'LP') {
      fileValue = (selectedFile.lpAgreeChange === 'Yes');
      if (yesno === 'YES') {
        result = fileValue ? 'True' : '';
      } else {
        result = fileValue ? '' : 'True';
      }
    }
    return result;
  }
  
  const allowEdit = function() {
    let allowEditResult = false;
    // console.log('>>> allowEdit:', mode, userInfo);
    if (mode === "admin" || 
        (userInfo && userInfo.is_rb) || 
        (userInfo && userInfo.is_lp)) {
      allowEditResult = true;
    }
    // console.log('allowEdit result:', allowEditResult);
    return allowEditResult;
  }
  
  const getReviewStatusDisabled = (item) => {
    return (item.id == 5 || item.id == 6) ? 'true' : '';
  }
  
  return (
    <div className="NavSub">
      <Container fluid>
        <Row>
          <Col md={3} className="nav-sub-container">
            <div className="subtitle">TLF OUTPUT REVIEW</div>
          </Col>
          { allowEdit() ?
          <Col md={9} className="nav-sub-container">
            <Form className="formInline">
              <Form.Group controlId="reviewStatusSelect">
                <Form.Control as="select" onChange={onSelectReviewStatus} value={getSelectFileStatusId()} >
                  {userInfo.reviewStatus.map((statusItem, index) => (
                    <option key={statusItem.id} value={statusItem.id} disabled={getReviewStatusDisabled(statusItem)} >
                      {statusItem.status}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form>
            <Form className="formInline formAgreeSelect">
              <Form.Group controlId="RbControlSelect" size="sm">
                <Form.Label className={ userInfo.is_rb ? 'labelInline' : 'labelInline text-muted' }>
                  Biostatistician Require Change
                </Form.Label>
                <Form.Check inline label="Yes" type="radio" disabled={ userInfo.is_rb ? '':true }
                  name="rb-agree" id="rb-change-yes" data-value="Yes" checked={getCheckedValue("RB", "YES")}
                  onClick={onRbAgreeClick} />
                <Form.Check inline label="No" type="radio" disabled={ userInfo.is_rb ? '':true }
                  name="rb-agree" id="rb-change-no" data-value="No" checked={getCheckedValue("RB", "NO")}
                  onClick={onRbAgreeClick} />
              </Form.Group>
            </Form>
            <Form className="formInline formAgreeSelect">
              <Form.Group controlId="LpControlSelect3" size="sm">
                <Form.Label className={ userInfo.is_lp ? 'labelInline' : 'labelInline text-muted' }>
                  Lead Programmer Agree with Change
                </Form.Label>
                <Form.Check inline label="Yes" type="radio" disabled={ userInfo.is_lp ? "":true }
                  name="lp-agree" id="lp-agree-yes" data-value="Yes" checked={getCheckedValue("LP", "YES")}
                  onClick={onLpAgreeClick} />
                <Form.Check inline label="No" type="radio" disabled={ userInfo.is_lp ? "":true }
                  name="lp-agree" id="lp-agree-no" data-value="No" checked={getCheckedValue("LP", "NO")}
                  onClick={onLpAgreeClick} />
              </Form.Group>
            </Form>
          </Col>
          : ""}
        </Row>
      </Container>
    </div>
  );
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
})

const mapDispatch = dispatch => ({
  startUpdateOutputFileStatus: (data) => dispatch(updateOutputFileStatus(data)),
  startSetOutputFileAttribute: (data) => dispatch(setOutputFileAttribute(data)),
  startUpdateStatusByRB: (data) => dispatch(updateStatusByRB(data)),
  startUpdateStatusByLP: (data) => dispatch(updateStatusByLP(data)),
})

export default connect(mapState, mapDispatch)(NavSub);
